import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungGuetersloh() {
  return (
    <CityPageTemplate
      city="Gütersloh"
      slug="guetersloh"
      intro="Gütersloh als Medienstadt und Wirtschaftszentrum Ostwestfalens – smarte Finanzberatung für eine starke Region."
      description="Unabhängige & digitale Finanzberatung für Gütersloh: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
